<template>
  <section class="container">
    <div
      id='editor'
      ref="editor"/>
    <el-upload
      class="upload-demo"
      :action="uploadDomain"
      :data="uploadData"
      :on-success="uploadSuccess"
      :show-file-list="false"
      list-type="picture">
      <el-button
        ref="file_click"
        size="small"
        style="display: none;"
        type="primary">点击上传</el-button>
    </el-upload>
  </section>
</template>

<script>
/* eslint-disable vue/no-reserved-keys,vue/require-default-prop,no-unused-vars
,prefer-destructuring,no-underscore-dangle */

import _Quill from 'quill';
import env from '@/configs/env'
import getQiniuInfo, { uploadQiniu } from '@/api/api'
import { setTimeout } from 'timers';

const Quill = window.Quill || _Quill;

export default {
  data() {
    return {
      _value: '',
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
    };
  },

  props: {
    option: {
      type: Object,
      default: () => ({
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              // [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }],
              [{ align: [] }],
              ['clean'],
              ['image'],
            ],
            handlers: {
            },
          },
        },
      })
      ,
    },
    value: String,
  },

  async mounted() {
    // 初始富文本编辑器
    await this.initialize();
    await this.network().getQiniuInfo()
    this.quill.getModule('toolbar').addHandler('image', this.imgHandler)
  },

  destroyed() {
    // 销毁富文本编辑器
    this.quill = null;
    delete this.quill;
  },

  methods: {
    imgHandler(state) {
      if (state) {
        this.$refs.file_click.$el.click();
      }
    },
    uploadSuccess(res) {
      this.addRange = this.quill.getSelection()
      this.quill.insertEmbed(this.addRange !== null ? this.addRange.index : 0, 'image', this.qiniuDomain + res.hash, _Quill.sources.USER)
      this.quill.setSelection(this.addRange.index + 1)
    },
    initialize() {
      // 注意不要使用ID选择来初始化编辑器，否则无法在同一个页面初始两个组件
      this.quill = new Quill(this.$refs.editor, this.option);

      // 解析传入的值
      if (this.value) {
        this.quill.pasteHTML(this.value);
      }

      // API事件：https://quilljs.com/docs/api/#events
      // 监听文本的变化
      this.quill.on('text-change', (delta, olddelta, source) => {
        let html = this.$refs.editor.children[0].innerHTML;

        const quill = this.quill;
        const text = this.quill.getText();

        if (html === '<p><br></p>') html = '';

        this._value = html;

        this.$emit('input', html);

        this.$emit('change', {
          html,
          text,
          quill,
        });
      });
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
      }
    },
  },

  watch: {
    value(nv, ov) {
      if (!this.quill) return;

      if (nv && nv !== this._value) {
        this._value = nv;
        this.quill.pasteHTML(nv);
        return;
      }

      if (!nv) {
        this.quill.setText('');
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/quill-editor.vue